import { jsx, jsxs } from "react/jsx-runtime";
import { Box, Stack, Columns, Column, Text } from "braid-design-system";
import { tableRowBorder } from "./styles.css.mjs";
const TeamMemberJobAccessMobileLayout = ({ accessSection, email, name, notifySection }) => /* @__PURE__ */ jsx(
  Box,
  {
    paddingY: "medium",
    paddingX: ["medium", "small"],
    background: "surface",
    className: tableRowBorder,
    children: /* @__PURE__ */ jsxs(Stack, { space: "medium", children: [
      /* @__PURE__ */ jsx(LabelValue, { label: name.label, value: name.value }),
      /* @__PURE__ */ jsx(LabelValue, { label: email.label, value: email.value }),
      /* @__PURE__ */ jsx(LabelValue, { label: accessSection.label, value: accessSection.value }),
      /* @__PURE__ */ jsx(LabelValue, { label: notifySection.label, value: notifySection.value })
    ] })
  }
);
const LabelValue = ({ label, value }) => /* @__PURE__ */ jsxs(Columns, { alignY: "top", space: "small", children: [
  /* @__PURE__ */ jsx(Column, { width: "1/3", children: /* @__PURE__ */ jsx(Text, { size: "small", weight: "strong", baseline: false, children: label }) }),
  /* @__PURE__ */ jsx(Column, { width: "2/3", children: value })
] });
export {
  TeamMemberJobAccessMobileLayout
};
